import React from 'react'

const Sixty_two = () => {
    return (
        <div className='container'>
            <h1>N-queen problem</h1>
            <div className='containers'>
            N Queens Problem is a famous puzzle in which n-queens are to be placed on 
            a nxn chess board such that no two queens are in the same row, column or
             diagonal.The N Queen is the problem of placing N chess queens on an N×N 
             chessboard so that no two queens attack each other. <br />
             <b>For example</b>: <br />
              following is a solution for 4 Queen problem.
              One of the most common examples of the backtracking is to arrange N 
              queens on an NxN chessboard such that no queen can strike down any other 
              queen. A queen can attack horizontally, vertically, or diagonally. The 
              solution to this problem is also attempted in a similar way. We first 
              place the first queen anywhere arbitrarily and then place the next queen 
              in any of the safe places. We continue this process until the number of
               unplaced queens becomes zero (a solution is found) or no safe place is
                left. If no safe place is left, then we change the position of the 
                previously placed queen. <br />

            </div>
               <div className='containers'>
               #include &lt;stdio.h &gt;<br/>

#include&lt;math.h &gt;<br/>

 int board[20],count;<br/>

 int main()&#123;

 int n,i,j;<br/>

 void queen(int row,int n);<br/> 

 printf(" - N Queens Problem Using Backtracking -");<br/>

 printf("\n\nEnter number of Queens:");<br/>

 scanf("%d",&n);<br/>

 queen(1,n);<br/>

 return 0;<br/>

 &#125;<br/>

//function for printing the solution<br/>

void print(int n)

&#123;<br/>

 int i,j;<br/>

 printf("\n\nSolution %d:\n\n",++count;<br/>

 for(i=1;i&lt;=n;++i)

  printf("\t%d",i;<br/>

 for(i=1;i&lt;=n;++i)

 &#123;<br/>

  printf("\n\n%d",i);<br/>

  for(j=1;j&lt;=n;++j) //for nxn board

  &#123;<br/>

   if(board[i]==j)

    printf("\tQ"); //queen at i,j position

   else

    printf("\t-"); //empty slot   &#125; &#125;&#125; <br/>

/funtion to check conflicts If no conflict for desired postion returns 1 otherwise returns 0/<br/>

int place(int row,int column)

&#123;<br/>

 int i;<br/>

 for(i=1;i&lt;=row-1;++i) &#123;<br/>

 //checking column and digonal conflicts<br/>

  if(board[i]==column)

   return 0;<br/>

  else

   if(abs(board[i]-column)==abs(i-row))

    return 0;<br/>  &#125;<br/> return 1; <br/> //no conflicts<br/>
&#125;<br/>
  

//function to check for proper positioning of queen<br/>

void queen(int row,int n)&#123;<br/>

 int column;<br/>

 for(column=1;column&lt;=n;++column) &#123;<br/>

  if(place(row,column))  &#123;<br/>

   board[row]=column;<br/> //no conflicts so place queen<br/>

   if(row==n) //dead end<br/>

    print(n);<br/> //printing the board configuration<br/>

   else //try queen with next position<br/>

    queen(row+1,n);<br/>   &#125;<br/> &#125;<br/> &#125;<br/>
               </div>
        </div>
    )
}

export default Sixty_two
